<template>
  <div id="cookie-banner-main-div">
    <p>{{ $t('cookieBanner.infoMsg') }}</p>
    <!--
      The action links form a wrapping row (see .cookie-banner-buttons):
      at wide viewports they stay on a single line, at narrow viewports
      they flow to additional lines so the banner cannot stretch the page
      horizontally.
    -->
    <div class="cookie-banner-buttons">
      <a
        class="cookie-banner-clickable"
        href="#"
        :aria-label="$t('cookieBanner.acceptBtn').toString()"
        @click="acceptClicked()"
        >{{ $t('cookieBanner.acceptBtn') }}</a
      >
      <a
        class="cookie-banner-clickable"
        href="#"
        :aria-label="$t('cookieBanner.declineBtn').toString()"
        @click="declineClicked()"
        >{{ $t('cookieBanner.declineBtn') }}</a
      >
      <a
        class="cookie-banner-clickable"
        href="https://www.molit.eu/datenschutzerklaerung/"
        target="_blank"
        >{{ $t('cookieBanner.privacyBtn') }}</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['trackingDeclined', 'trackingAccepted'],

  methods: {
    acceptClicked() {
      this.$emit('trackingAccepted');
    },
    declineClicked() {
      this.$emit('trackingDeclined');
    },
  },
});
</script>

<style lang="scss" scoped>
#cookie-banner-main-div {
  background-color: rgba(1, 1, 2, 0.603);
  color: whitesmoke;
  font-size: 1.125rem;
  padding: 1rem 0.5rem 1.5rem;
}

.cookie-banner-clickable {
  margin: 1rem;
  color: rgb(130, 205, 255);
  font-size: larger;
}

// Wrapping row for the action links: at wide viewports all links fit on
// one line (unchanged look); at narrow viewports they flow to additional
// lines instead of stretching the page horizontally.
.cookie-banner-buttons {
  display: flex;
  flex-wrap: wrap;
}

// Mobile: compact banner. The full legal text is kept verbatim, but the
// reduced padding, font size and line height keep the banner short so it
// does not squeeze the content area on phones. With the reduced margins
// the three action links fit on a single line at 375px.
@media (max-width: 1399.98px) {
  #cookie-banner-main-div {
    padding: 0.75rem 0.5rem;
    font-size: 0.8125rem;
    line-height: 1.4;
  }

  #cookie-banner-main-div p {
    margin-bottom: 0.5rem;
  }

  .cookie-banner-clickable {
    margin: 0.25rem 0.375rem;
    font-size: 0.875rem;
  }
}
</style>
